import { useCallback, useEffect } from 'react'
import Breadcrumbs from './../../../components/Common/Breadcrumb'
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
} from "reactstrap"
import { AGENT_USER_TYPE_ID, ERROR_KEY, MERCHANT_USER_TYPE_ID } from './../../../Constants/MainKeys'
import { addRightSectionSpinner, removeRightSectionSpinner } from './../../../store/spinner/actions'
import AlertService from '../../../Services/alertService'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import uuid from 'react-uuid'
import ApiService from '../../../Services/ApiService'
import { useState } from 'react'
import moment from 'moment'
import { Link, withRouter } from 'react-router-dom'
import MainService from '../../../Services/MainService'
import NoData from '../../../components/NoData/NoData'
import StepLine from '../../../components/StepLine/StepLine'
import OverlayTriggerComponent from '../../../components/OverlayTriggerComponent/OverlayTriggerComponent'
import { useWindowSize } from '../../../components/Hooks/useWindowSize'
import { Button } from 'react-bootstrap'
import ShortLinks from '../../../components/ShortLinks/ShortLinks'
import { useTranslation } from '../../../lang/TranslationProvider'

const Dashboard = (props) => {

  const { translate } = useTranslation();
  const windowSize = useWindowSize();
  const dispatch = useDispatch();
  const title = "Dashboard";
  const description = "";
  const { user } = useSelector(state => state.Login);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const [data, setData] = useState(null);
  const { language } = useSelector(state => state.Languages);

  const [transactions, setTransactions] = useState([]);
  const [isShowBalance, setIsShowBalance] = useState(false);
  const [balance, setBalance] = useState(null);


  useEffect(() => {
    if (user && user.userTypeId === MERCHANT_USER_TYPE_ID) {
      getTransactionHistoryAsMerchant();
      getDashbordData();
      getBalance();
    }
  }, [user])

  const getBalance = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getBalance().then(response => {
      if (response && response.data && response.data.length) {
        setBalance(response.data[0])
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  const getTransactionHistoryAsMerchant = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    const _filter = {
      createDate: null,
      cryptoMaxAmount: null,
      cryptoMinAmount: null,
      cryptoWalletId: null,
      currencyId: null,
      fiatMaxAmount: null,
      fiatMinAmount: null,
      finishDate: null,
      searchKey: null,
      status: null,
    }
    ApiService.getTransactionHistoryAsMerchant(1, 10, _filter).then(response => {
      if (response && response.data) {
        const data = { ...response.data };
        if (data && data.paymentHistory) {
          setTransactions(data.paymentHistory);
        } else {
          setTransactions([]);
        }
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  const getDashbordData = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getDashboardData().then(response => {
      if (response) {
        setData({ ...response });
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <Breadcrumbs
          title="Cryllex"
          breadcrumbItem="Dashboard"
        />
        <StepLine />
        {
          user && user.userTypeId === MERCHANT_USER_TYPE_ID ?
            <ShortLinks />
            : null
        }

        <Row>
          {
            user && user.userTypeId === MERCHANT_USER_TYPE_ID ?
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h5 className='mb-0'>Financial Overview</h5>
                    <hr />
                    <Row className='h-100'>
                      {
                        balance ?
                          <Col md={6}>
                            <div className='border rounded p-3 mt-xl-0 mt-3 h-100'>
                              <div className='d-flex justify-content-between align-items-center'>
                                <h5 className='m-0 text-primary'>Balance</h5>
                                {
                                  isShowBalance ?
                                    <i className="fa fa-eye text-primary fs-5"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setIsShowBalance(false)
                                      }}
                                    />
                                    :
                                    <i className="fa fa-eye-slash text-primary fs-5"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setIsShowBalance(true);
                                      }}
                                    />
                                }
                              </div>
                              <div className='d-flex gap-5'>
                                <div className='mt-4'>
                                  <h5>
                                    Total balance
                                  </h5>

                                  <p className="mb-2">
                                    {/* <i className="mdi mdi-arrow-right align-middle me-2 text-primary" />{" "} */}
                                    {
                                      isShowBalance ?
                                        <b className='cursor-pointer' onClick={() => setIsShowBalance(!isShowBalance)}> ${balance.amount || 0}</b>
                                        : <b className='cursor-pointer' onClick={() => setIsShowBalance(!isShowBalance)}>*****</b>
                                    }
                                  </p>
                                </div>
                                <div className='mt-4'>
                                  <h5>
                                    Available balance
                                  </h5>
                                  <p className="mb-2">
                                    {/* <i className="mdi mdi-arrow-right align-middle me-2 text-primary" />{" "} */}
                                    {
                                      isShowBalance ?
                                        <b className='cursor-pointer' onClick={() => setIsShowBalance(!isShowBalance)}>${balance.amount_OffRamp || 0}</b>
                                        : <b className='cursor-pointer' onClick={() => setIsShowBalance(!isShowBalance)}>*****</b>
                                    }
                                  </p>
                                </div>
                              </div>
                              <div className='d-flex justify-content-end'>
                                <Button size='sm' className='mt-2 mb-0' onClick={() => props.history.push(`/${language}/balance/payout/form`)}>
                                  Withdraw
                                </Button>
                              </div>
                              {/* <Link to={`/${language}/balance/payout/form`} className='d-block text-underline mt-4'>Withdraw</Link> */}
                            </div>
                          </Col>
                          : null
                      }
                      {/* {
                        data ?
                          <Col md={6}>
                            <div className='border rounded p-3 mt-xl-0 mt-3 h-100'>
                              <h5 className='m-0 text-primary  mb-3'>Quick Glance</h5>
                              <div className='mt-4'>
                                <h5>
                                  Gross Volume
                                </h5>
                                <p className="mb-2">
                                  <i className="mdi mdi-arrow-right align-middle me-2 text-primary" />{" "}
                                  {data?.grossVolume || 0}
                                </p>
                              </div>
                              <div className='mt-4'>
                                <h5>
                                  Successful Transactions
                                </h5>
                                <p className="mb-2">
                                  <i className="mdi mdi-arrow-right align-middle me-2 text-primary" />{" "}
                                  {data?.successTransactions || 0}
                                </p>
                              </div>
                              <div className='mt-4'>
                                <h5>
                                  Unique Paying Customers
                                </h5>
                                <p className="mb-2">
                                  <i className="mdi mdi-arrow-right align-middle me-2 text-primary" />{" "}
                                  {data?.payingCustomers || 0}
                                </p>
                              </div>
                            </div>
                          </Col>
                          : null
                      } */}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              : null
          }

          {
            user.userTypeId === MERCHANT_USER_TYPE_ID ?

              <Col xs={12}>
                <Row className='mb-5'>
                  <Col lg={12} >
                    <Card className='mb-0 h-100'>
                      <CardBody>
                        <div className='d-flex justify-content-between align-items-center'>
                          <h5 className='mb-0'>Recent Transactions</h5>
                          <Link className='text-underline' to={`/${language}/all-transactions`}>
                            <span>See All transactions</span>
                          </Link>
                        </div>
                        <hr />

                        {
                          transactions && transactions.length ? (
                            <Table striped bordered hover responsive>
                              <thead>
                                <tr className='cursor-default'>
                                  <th className='text-nowrap'>#</th>
                                  <th className='text-nowrap'>Transaction ID</th>
                                  <th className='text-nowrap'>Date</th>
                                  <th className='text-nowrap'>Paying Customer</th>

                                  <th className='text-nowrap'>Transaction Type</th>
                                  <th className='text-nowrap'>Transaction Value</th>
                                  <th className='text-nowrap'>Status</th>
                                  <th className={`text-nowrap ${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactions.map((transaction, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td> <span className='max-line-1' title={transaction.transactionId}>{transaction.transactionId}</span></td>
                                      <td className='text-nowrap'>{moment(MainService.convertUTCDateToLocalDate(new Date(transaction.createDate))).format("LL HH:mm")}</td>
                                      <td>{transaction.payingCustomerFullName}</td>
                                      <td>{transaction.transactionType}</td>

                                      <td>
                                        {(() => {
                                          if (transaction.amount) {
                                            return `${transaction.amount} USD`
                                          }
                                          const transactionValue = transaction?.transactionValue || [];
                                          if (!transactionValue?.length) return "";
                                          const crypto = transactionValue.find(el => el.name === "Crypto");
                                          const fiat = transactionValue.find(el => el.name === "Fiat");
                                          if (fiat) {
                                            return `${parseFloat(fiat.amount).toFixed(2)} ${fiat.currency}`;
                                          }
                                        })()}
                                      </td>
                                      <td className='text-nowrap'>
                                        <span className={`badge badge-soft-${MainService.getStatusColor(transaction.status)} font-size-14 badge badge-pill`}>
                                          {transaction.transactionStatus}
                                        </span>
                                      </td>
                                      <td className={`${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>
                                        <div className='d-flex flex-nowrap'>
                                          <OverlayTriggerComponent text='View Info'>
                                            <Link
                                              to={`/${language}/transaction/view/${transaction.transactionId}/${transaction.organizationId}`}
                                              className='shadow-sm me-2 text-nowrap btn btn-primary'
                                            >
                                              <i className="bx bx-show table-icon" />
                                            </Link>
                                          </OverlayTriggerComponent>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          ) : (
                            <NoData width={150} />
                          )
                        }
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
              : null
          }
          {
            user.userTypeId === AGENT_USER_TYPE_ID ?
              <Col sm={12}>
                <Card>
                  <CardBody>
                    <NoData />
                  </CardBody>
                </Card>
              </Col>
              : null
          }


        </Row>
      </div>
    </>
  )
}

export default withRouter(Dashboard)